const bodyScrollLock = {

  disableScroll: function(modal) {
    window.finanztip?.disableBodyScroll(modal);
  },

  enableScroll: function() {
      window.finanztip?.clearScrollLocks();
  }
}


export default bodyScrollLock;
